import { render, staticRenderFns } from "./SidebarExportSeeding.vue?vue&type=template&id=1b8d2f76&scoped=true&"
import script from "./SidebarExportSeeding.vue?vue&type=script&lang=ts&"
export * from "./SidebarExportSeeding.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarExportSeeding.vue?vue&type=style&index=0&id=1b8d2f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d2f76",
  null
  
)

export default component.exports